import React, { useEffect, useState } from 'react';
import { Card } from '../components/ui/card';
import { Loader2, Bell, Award, Flame, Megaphone } from 'lucide-react';
import { notificationsAPI } from '../services/api';

const ICON = { badge: Award, reminder: Flame, coach: Megaphone };

export default function Notifications() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    notificationsAPI.list().then((d) => setItems(d.items)).catch(() => setItems([]));
    notificationsAPI.read().catch(() => {});
    window.dispatchEvent(new Event('bfc-notif-read'));
  }, []);

  if (!items) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-red-600" /></div>;

  return (
    <div className="space-y-5 animate-rise">
      <div>
        <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-red-950 dark:text-red-50">Notifications</h1>
        <p className="text-muted-foreground text-sm mt-1">Tes rappels, badges et messages du coach</p>
      </div>

      {items.length === 0 ? (
        <Card className="p-10 rounded-2xl border-red-100 dark:border-red-900/50 flex flex-col items-center gap-3 text-center">
          <Bell className="w-12 h-12 text-red-300" />
          <p className="text-sm text-muted-foreground">Aucune notification pour l'instant.</p>
        </Card>
      ) : (
        <div className="space-y-2" data-testid="notifications-list">
          {items.map((n) => {
            const Icon = ICON[n.type] || Bell;
            return (
              <Card key={n.id} data-testid={`notif-${n.type}`} className={`p-4 rounded-2xl border-red-100 dark:border-red-900/50 flex items-start gap-3 ${!n.read ? 'bg-red-50/60 dark:bg-red-900/20' : ''}`}>
                <div className="w-9 h-9 rounded-xl bfc-gradient-warm text-white flex items-center justify-center shrink-0"><Icon className="w-5 h-5" /></div>
                <div className="flex-1">
                  <p className="text-sm font-semibold text-red-950 dark:text-red-50">{n.title}</p>
                  {n.body && <p className="text-xs text-muted-foreground mt-0.5">{n.body}</p>}
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
